import React from 'react';

const MainFooter = () => {
    return (
        <footer id='footer' className='footer'>
            <p>Copyright © 2017 Alliance Integrated System </p>
        </footer>
    );
};

export default MainFooter;
